import React from 'react'
import '../Styling/MobileMedications.css'

const MobMedicationsHeader = () => {
  return (
    <div className='medications-header' style={{ paddingTop: '30px' }}>
      <h2>My Medications</h2>
      <p>Manage your prescriptions and medication history</p>
    </div>
  )
}

export default MobMedicationsHeader
